const categories = [
  {
    label: "Transporte de Carga",
    description:
      "Servicio de carga de bienes, mercancías y productos a nivel nacional.",
    icon: "🚚",
  },
  {
    label: "Mantenimiento y Limpieza",
    description:
      "Servicio de mantenimiento de equipos industriales, y servicio de limpieza industrial para plantas, comercios y oficinas.",
    icon: "🛠️",
  },
  {
    label: "Marketing y Publicidad",
    description:
      "Agencias de marketing que te ayudarán con branding, material POP, diseño de logos, creación de eventos y mucho más.",
    icon: "👥",
  },
  {
    label: "Otro Servicio",
    description:
      "Escoge una de las categorías que manejamos y te ayudaremos a encontrar los mejores proveedores.",
    icon: "⚙️",
  },
];

export default categories;
